import {StyleSheet} from "aphrodite";

import {spacing} from "@khanacademy/wonder-blocks-tokens";
import {LayoutTwoColumns} from "@khan/component-layout-two-columns";
import {mediaQueries} from "@khan/shared-styles";

import {largeDesktopMin} from "#marketing-content-shared-package/media-queries.ts";

type Props = {
    /**
     * The left component of this layout. Designed for use with images/figures but should be flexible.
     * This will be hidden on small screens.
     */
    leftComponent: React.ReactNode;
    /**
     * The right component of this layout. Designed for use with forms but should be flexible.
     */
    rightComponent: React.ReactNode;
    /**
     * The CSS Grid column template for the grid layout. Defaults to "1fr 40%".
     */
    columnTemplate?: string;
};

/**
 * A modal layout with two columns. On small screens (smOrSmaller), the content
 * is layed out "1fr 1fr", On xSmall screens (xsOrSmaller), the left component
 * is positioned below the right component. There is a default gap of 10px
 * between the columns.
 */
export const LohpTwoColumns = ({
    leftComponent,
    rightComponent,
    columnTemplate = "1fr 1fr",
}: Props) => {
    return (
        <LayoutTwoColumns
            leftComponent={leftComponent}
            rightComponent={rightComponent}
            style={[styles.container, {gridTemplateColumns: columnTemplate}]}
            leftColumnStyle={styles.leftColumn}
            rightColumnStyle={styles.rightColumn}
        />
    );
};

const styles = StyleSheet.create({
    container: {
        width: "100%",
        maxWidth: largeDesktopMin,
        margin: "0 auto",

        [mediaQueries.smOrSmaller]: {
            gridTemplateColumns: "100%",
        },
        justifyItems: "center",
    },
    leftColumn: {
        padding: `${spacing.xLarge_32}px ${spacing.large_24}px ${spacing.large_24}px`,
        width: "100%",
        // Move the left column below the right column on xSmall screens
        order: 1,
        [mediaQueries.smOrLarger]: {
            order: 0,
        },
        [mediaQueries.lgOrLarger]: {
            padding: `${spacing.xLarge_32}px ${spacing.xxLarge_48}px ${spacing.xxLarge_48}px`,
            maxWidth: 615,
        },
    },
    rightColumn: {
        padding: `${spacing.xLarge_32}px ${spacing.large_24}px ${spacing.large_24}px`,
        width: "100%",
        [mediaQueries.lgOrLarger]: {
            padding: `${spacing.xLarge_32}px ${spacing.xxLarge_48}px ${spacing.xxLarge_48}px`,
            width: 496,
        },
    },
});
